var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversationsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50.9.8c-11.2.2-19.5 0-30.7.1-2.6 0-5 .9-6.9 2.3-2.6 2-4.4 5.1-4.5 8.6-.1 4.2-.2 8.4 1.4 12.4.8 1.9 1.8 3.6 3 5.1 2.6 3.4 6.4 6 10.5 7.2 4.7 1.4 7.1.7 12 .7h15c.4 0 .8.2 1.1.5.1.1.2.2.2.2l8.9 8.9c.5.5 1.4.1 1.4-.6 0 0 0-26.6 0-33.9v-.3c0-6.8-5.7-11.3-11.4-11.2zm8.8 41.1c-2-2-4.3-4.3-5.8-5.8l-.3-.3c-.7-.7-1.9-1.2-2.9-1.2-5 0-10 0-15 0-1.3 0-2.4 0-3.4.1-2.8.1-4.7.2-7.8-.7-3.4-1-6.8-3.3-9.2-6.3-1.1-1.4-2-2.9-2.6-4.5-1.5-3.6-1.4-7.5-1.2-11.4.1-2.6 1.3-5 3.4-6.6 1.5-1.2 3.4-1.8 5.4-1.8h10c6.7 0 13 0 20.7-.1 2.2 0 4.5.9 6.1 2.5 1.1 1.1 2.5 3.1 2.5 6.1v30z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.1,
    cy: 18.6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 18.6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 18.6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.4 40.8c-.8 0-1.6 0-2.3 0h-.2v.2c-.2.8-.4 1.5-.7 2.1-.5 1.3-1.3 2.6-2.2 3.7-2 2.5-4.7 4.4-7.6 5.3-2 .6-3.3.7-4.5.7-.5 0-1.1 0-1.9-.1h-.3c-.7 0-1.5-.1-2.5-.1h-11.9c-.6 0-1.4.3-1.8.8l-.2.2c-.9.8-2 2-3.2 3.1l-2.7 2.7v-25.4c0-2.7 1.4-5.1 3.7-6.5l.2-.1-.1-.2c-.4-.7-.7-1.4-1-2.1l-.1-.1-.2.1c-3.3 1.9-5.2 5.1-5.2 8.9v.3 27c0 1.1.9 2 2 2 .5 0 1-.2 1.4-.6l7.3-7.2h.2 11.6c.9 0 1.8 0 2.6.1h2c1.3 0 3-.1 5.3-.8 3.4-1 6.6-3.2 9-6.2 1.1-1.3 1.9-2.8 2.6-4.4.4-1 .7-2 .9-3.1v-.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationsIcon);
export default __webpack_public_path__ + "static/media/conversations-icon.d1c1371427b67776dff2cf36cfdb984e.svg";
export { ForwardRef as ReactComponent };